import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import BookingBanner from '../components/BookingBanner'

export default function PricesPage() {
  return (
    <>
      <MetaTags
        title="Priser - Trine Rosendal"
        description="Priser hos Trine Rosendal. Pris pr. behandling: 1400,- DKK (Søndag 1600,- DKK). 1 time og 20 min. afsat pr. behandling inkl. fri mailvejledning."
        image="https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/cat-1011-scaled.jpg"
        canonicalUrl="https://trine-rosendal.dk/priser"
      />

      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-8 sm:py-14 space-y-12 sm:space-y-16">
        {/* Breadcrumbs */}
        <nav aria-label="Brødkrummer" className="flex items-center gap-2 text-xs text-[#5C6E52]">
          <Link to="/" className="hover:text-[#222E1D]">
            Forside
          </Link>
          <span>/</span>
          <span className="font-medium text-[#222E1D]">Priser</span>
        </nav>

        {/* Header Introduction */}
        <div className="max-w-3xl space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#D6E2CB] bg-[#EEF3E8] px-3.5 py-1 text-xs font-medium text-[#4C5E43]">
            <i className="fa-solid fa-tag text-[11px] text-[#556B48]" aria-hidden="true" />
            <span>Gennemskuelige vilkår & priser</span>
          </div>

          <h1 className="font-serif text-3.5xl sm:text-4xl lg:text-5xl font-medium text-[#222E1D] tracking-tight">
            Priser
          </h1>

          <p className="text-base sm:text-lg text-[#4D5E46] leading-relaxed">
            Jeg afsætter god tid til hver behandling, så du opnår tryghed, ro og de bedste forudsætninger for en varig udvikling.
          </p>
        </div>

        {/* Hero Clinic Image */}
        <div className="overflow-hidden rounded-3xl border border-[#DFE6D5] bg-[#F6F8F3] shadow-sm">
          <img
            src="/cdn-cgi/image/width=1200,quality=85,format=auto/_assets/cat-1011-scaled.jpg"
            alt="Klinikken i Holstebro"
            className="h-[300px] sm:h-[400px] w-full object-cover"
            onError={(e) => {
              e.currentTarget.src =
                'https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/cat-1011-scaled.jpg'
            }}
          />
        </div>

        {/* Pricing Cards (Verbatim from Scrape) */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-stretch">
          {/* Standard Treatment Card */}
          <div className="rounded-3xl border-2 border-[#556B48]/50 bg-[#F7F9F3] p-7 sm:p-9 shadow-md flex flex-col justify-between">
            <div className="space-y-4">
              <div className="flex items-center justify-between gap-3">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#556D48]">
                  Individuel behandling i klinikken
                </span>
                <span className="shrink-0 rounded-full bg-[#E2EBD9] px-3 py-1 text-xs font-medium text-[#3E5234]">
                  Hverdage
                </span>
              </div>

              <div className="flex flex-wrap items-baseline gap-2">
                <span className="font-serif text-4xl sm:text-5xl font-medium text-[#222E1D]">
                  1.400,-
                </span>
                <span className="text-sm font-medium text-[#5C6E52]">DKK pr. behandling</span>
              </div>

              <div className="border-t border-[#D6E2CB] pt-4 space-y-3.5 text-sm text-[#4D5E46] leading-relaxed">
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-clock text-[#556B48] mt-1 shrink-0" aria-hidden="true" />
                  <span>
                    <strong>Varighed:</strong> Jeg afsætter 1 time og 20 min. til hver behandling.
                  </span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-envelope-open-text text-[#556B48] mt-1 shrink-0" aria-hidden="true" />
                  <span>
                    <strong>Fri mail:</strong> Mellem behandlingerne er der ligeledes fri mail – hvilket vil sige, jeg står til rådighed med vejledning, hvis du føler behov. Dette er en stor hjælp i et udviklingsforløb.
                  </span>
                </div>
              </div>
            </div>

            <div className="pt-8">
              <a
                href="https://system.easypractice.net/book/online-booking-16"
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-full items-center justify-center gap-2 rounded-full bg-[#5C7A4F] px-6 py-3.5 text-sm font-medium text-white shadow-sm transition hover:bg-[#455C3A]"
              >
                <i className="fa-solid fa-calendar-check text-xs text-[#E2EBD9]" aria-hidden="true" />
                <span>Book tid i hverdagen</span>
              </a>
            </div>
          </div>

          {/* Sunday Treatment Card - Warm Yellow Accent Card */}
          <div className="rounded-3xl border-2 border-[#ECC572] bg-gradient-to-br from-[#FFFDF7] to-[#FEF8E8] p-7 sm:p-9 shadow-sm flex flex-col justify-between">
            <div className="space-y-4">
              <div className="flex items-center justify-between gap-3">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#935D08]">
                  Weekendmulighed
                </span>
                <span className="shrink-0 rounded-full bg-[#FEEEC7] px-3 py-1 text-xs font-semibold text-[#8C5508]">
                  Søndag
                </span>
              </div>

              <div className="flex flex-wrap items-baseline gap-2">
                <span className="font-serif text-4xl sm:text-5xl font-medium text-[#222E1D]">
                  1.600,-
                </span>
                <span className="text-sm font-medium text-[#6B5A42]">DKK pr. behandling</span>
              </div>

              <div className="border-t border-[#ECC572]/50 pt-4 space-y-3.5 text-sm text-[#4D4536] leading-relaxed">
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-calendar-day text-[#D08C1D] mt-1 shrink-0" aria-hidden="true" />
                  <span>
                    Som noget nyt giver jeg mulighed for at holde åbent om søndagen, hvis vi ikke kan finde en tid i hverdagen som passer dig.
                  </span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-clock text-[#D08C1D] mt-1 shrink-0" aria-hidden="true" />
                  <span>Der afsættes 1 time og 20 minutter til behandlingen.</span>
                </div>
              </div>
            </div>

            <div className="pt-8">
              <a
                href="https://system.easypractice.net/book/online-booking-16"
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-full items-center justify-center gap-2 rounded-full border border-[#ECC572] bg-[#FFF8E6] px-6 py-3.5 text-sm font-semibold text-[#7A4B05] transition hover:bg-[#FDECC0]"
              >
                <i className="fa-solid fa-calendar-check text-xs text-[#D08C1D]" aria-hidden="true" />
                <span>Book søndagstid</span>
              </a>
            </div>
          </div>
        </div>

        {/* Payment Methods & Telephone treatment box */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Betalingsmuligheder */}
          <div className="rounded-2xl border border-[#D6E2CB] bg-[#F7F9F3] p-6 sm:p-7 space-y-3">
            <h3 className="font-serif text-lg font-medium text-[#222E1D]">
              Betalingsmuligheder
            </h3>
            <ol className="space-y-2 text-sm text-[#4D5E46]">
              <li className="flex items-center gap-2.5">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#E2EBD9] text-xs font-semibold text-[#5c7a4f]">
                  1
                </span>
                <span>Du kan betale med MobilePay</span>
              </li>
              <li className="flex items-center gap-2.5">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#E2EBD9] text-xs font-semibold text-[#5c7a4f]">
                  2
                </span>
                <span>Du kan betale kontant</span>
              </li>
            </ol>
          </div>

          {/* Tryghed & forløb info box */}
          <div className="rounded-2xl border border-[#D6E2CB] bg-[#F7F9F3] p-6 sm:p-7 space-y-3">
            <h3 className="font-serif text-lg font-medium text-[#222E1D]">
              Spørgsmål til din behandling?
            </h3>
            <p className="text-xs text-[#4D5E46] leading-relaxed">
              Er du i tvivl om, hvorvidt hypnoterapi kan hjælpe på netop din problemstilling? Du er altid meget velkommen til at kontakte mig for en uforpligtende snak inden booking.
            </p>
            <div className="flex flex-wrap items-center gap-4 text-xs font-medium text-[#222E1D] pt-1">
              <a
                href="tel:42510105"
                className="inline-flex items-center gap-1.5 rounded-lg bg-[#E2EBD9] px-3 py-1.5 text-[#3D5234] hover:bg-[#D6E2CB] transition"
              >
                <i className="fa-solid fa-phone text-[11px]" aria-hidden="true" />
                <span>42 51 01 05</span>
              </a>
              <Link
                to="/kontakt"
                className="text-xs font-medium text-[#5C7A4F] underline hover:text-[#222E1D]"
              >
                Gå til kontaktsiden →
              </Link>
            </div>
          </div>
        </div>

        <BookingBanner
          title="Bestil din tid direkte online"
          description="Vælg den dag og det tidspunkt, der passer dig bedst. Du er også velkommen til at ringe eller skrive en mail, hvis du vil høre mere inden tidsbestilling."
        />
      </div>
    </>
  )
}
